import { configureStore } from '@reduxjs/toolkit';
import subscriptionReducer from './Reducers/subscriptionSlice';
import storyElementReducer from './Reducers/storyElementSlice';
import wizardReducer from './Reducers/wizardSlice';
import demoReducer from './Reducers/demoSlice';
import { RootState } from './types';
import { persistStore, persistReducer, FLUSH, REHYDRATE, PAUSE, PERSIST, PURGE, REGISTER } from 'redux-persist';
import storage from 'redux-persist/lib/storage';

// Separate persist configs for each reducer
const wizardPersistConfig = {
    key: 'wizard',
    storage,
    blacklist: [] // Persist everything in wizard state
};

const storyElementPersistConfig = {
    key: 'storyElement',
    storage,
    blacklist: [] // Persist everything in storyElement state
};

const subscriptionPersistConfig = {
    key: 'subscription',
    storage,
    blacklist: ['isLoading', 'error'] // Don't persist loading and error states
};

const persistedWizardReducer = persistReducer(wizardPersistConfig, wizardReducer);
const persistedStoryElementReducer = persistReducer(storyElementPersistConfig, storyElementReducer);
const persistedSubscriptionReducer = persistReducer(subscriptionPersistConfig, subscriptionReducer);

export const store = configureStore({
    reducer: {
        subscription: persistedSubscriptionReducer,
        storyElement: persistedStoryElementReducer,
        wizard: persistedWizardReducer,
        demo: demoReducer
    },
    middleware: (getDefaultMiddleware) =>
        getDefaultMiddleware({
            serializableCheck: {
                ignoredActions: [FLUSH, REHYDRATE, PAUSE, PERSIST, PURGE, REGISTER],
            },
        }),
});

export const persistor = persistStore(store);

export type { RootState };
export type AppDispatch = typeof store.dispatch; 